import {
  Box,
  Button,
  Grid,
  MenuItem,
  Paper,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { ErrorMessage, Formik } from "formik";
import React, { useMemo } from "react";
import { useStyles } from "./styles";
import Close from "../../../assets/images/CourseManagement/close.svg";
import useSemester from "../../../Hooks/semester";
import useCourse from "../../../Hooks/course";
import CustomExpandMore from "../../../common/CustomExpandMore";
import useMyClass from "../../../Hooks/myClass";
import * as Yup from "yup";
import CustomPagination from "../../../common/Pagination";
import { useState } from "react";
import usePagination from "../../../common/usePagination";
import { useCallback } from "react";
import DeleteModal from "../../../common/DeleteModal";
import moment from "moment";
import { useRef } from "react";
import DropZoneUpload from "../../../common/DropZoneUpload";
import useAuthStore from "../../../Hooks/auth";
import { DateRangePicker } from "rsuite";
import Loader from "../../../common/Loader";
import { toast } from "react-toastify";
import { scrolltoView } from "../../../Utils/scrollToView";
import useCircular from "../../../Hooks/circular";

// import CustomDateRangePicker from "../../../common/SixDayCalendar/CustomDateRangePicker";

// const columns = [
//   {
//     id: "id",
//     sortby: true,
//     label: "S No",
//     align: "center",
//   },
//   {
//     id: "weekDay",
//     sortby: true,
//     label: "Day",
//     align: "center",
//   },
//   {
//     id: "name",
//     sortby: true,
//     label: "Name",
//     align: "center",
//   },

//   {
//     id: "start_time",
//     label: "Start Time",
//     align: "center",
//     sortby: true,
//   },
//   {
//     id: "end_time",
//     label: "End Time",
//     align: "center",
//     sortby: true,
//   },
//   {
//     id: "fromDate",
//     sortby: true,
//     label: "From Date",
//     align: "center",
//   },
//   {
//     id: "toDate",
//     label: "To Date",
//     align: "center",
//     sortby: true,
//   },
//   {
//     id: "courseName",
//     label: "Course",
//     align: "center",
//   },
//   {
//     id: "year",
//     label: "Year",
//     align: "center",
//   },
//   // {
//   //   id: "delete",
//   //   label: "Action",
//   //   align: "center",
//   // },
// ];

const grouped = (products, key) =>
  products &&
  products.length > 0 &&
  products.reduce((result, product) => {
    const category = product[key];
    if (!result[category]) {
      result[category] = [];
    }
    result[category].push(product);
    return result;
  }, {});

const sortingWithTime = (columns) => {
  return columns.sort(function (a, b) {
    const time1 = a.start_time;
    const time2 = b.start_time;
    // Convert time1 to 24-hour format
    const time1Formatted = moment(time1, "hh:mmA").format("HH:mm");

    // Create moment objects for each time
    const momentTime1 = moment().set({
      hour: time1Formatted.split(":")[0],
      minute: time1Formatted.split(":")[1],
    });
    const momentTime2 = moment(time2, "hh:mmA");

    // Get the difference between the two times in minutes
    const diffInMinutes = momentTime1.diff(momentTime2, "minutes");

    if (diffInMinutes > 0) {
      console.log(`${time2} is greater than ${time1}`);
    } else if (diffInMinutes < 0) {
      console.log(`${time1} is greater than ${time2}`);
    } else {
      console.log(`${time1} and ${time2} are the same time`);
    }

    return diffInMinutes;
  });
};
const order = {
  sunday: 1,
  monday: 2,
  tuesday: 3,
  wednesday: 4,
  thursday: 5,
  friday: 6,
  saturday: 7,
};

const myClassSchema = Yup.object().shape({
  courseName: Yup.string().required("* Please select course"),
  // year: Yup.string().required("* Please select semester year"),
  // startTime: Yup.string().required("* Please select start time"),
  // endTime: Yup.string().required("* Please select end time"),
  // periodOrder: Yup.string().required("* Please enter period order"),
  fromDate: Yup.date().required("* Please select week").nullable(),
  // toDate: Yup.date().required("* Please select week").nullable(),
  // name: Yup.string().required("* Please enter name"),
});

const MyClasses = () => {
  const { userId } = useAuthStore();
  const [filterDate, setFilterDate] = useState([
    moment(new Date()).startOf("isoWeek")._d,
    moment(new Date()).endOf("isoWeek")._d,
  ]);
  const { getSemesterAction, semesterData } = useSemester();
  const addClassRef = useRef();
  const {
    getClassesAction,
    classData,
    addClassesAction,
    getActiveClassAction,
    deleteClassesAction,
    activeClass,
    setActiveClassesAction,
    loading,
    uploadLoading,
  } = useMyClass();
  const { redirect, setRidirectAction } = useCircular();
  const {
    getDepartmentAction,
    departmentData,
    courseData,
    getAllCourseAction,
  } = useCourse();
  const [file, setFile] = useState(null);
  const [mediaURL, setMediaURL] = useState("");
  const [date, setDate] = useState([]);
  const [page, setPage] = useState(1);
  const [PerPage, setPerPage] = useState(10);
  const [offset, setOffset] = useState(0);
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  function getUniqueListBy(arr, key) {
    return [...new Map(arr?.map((item) => [item[key], item])).values()];
  }

  const columns = getUniqueListBy(classData, "start_time");

  const col = columns.sort(function (a, b) {
    const time1 = a.start_time;
    const time2 = b.start_time;
    // Convert time1 to 24-hour format
    const time1Formatted = moment(time1, "hh:mmA").format("HH:mm");

    // Create moment objects for each time
    const momentTime1 = moment().set({
      hour: time1Formatted.split(":")[0],
      minute: time1Formatted.split(":")[1],
    });
    const momentTime2 = moment(time2, "hh:mmA");

    // Get the difference between the two times in minutes
    const diffInMinutes = momentTime1.diff(momentTime2, "minutes");

    if (diffInMinutes > 0) {
      console.log(`${time2} is greater than ${time1}`);
    } else if (diffInMinutes < 0) {
      console.log(`${time1} is greater than ${time2}`);
    } else {
      console.log(`${time1} and ${time2} are the same time`);
    }

    return diffInMinutes;
  });

  console.log("col", col);
  const handlePage = (e) => {
    setPerPage(e.target.value);
    setPage(1);
  };
  const { institutionId } = useAuthStore();

  const tableD = getUniqueListBy(classData, "weekDay");

  const tabledata = React.useMemo(() => {
    return grouped(classData, "weekDay");
  }, [classData]);
  const tableData = tableD.sort(function sortByDay(a, b) {
    let day1 = a.weekDay.toLowerCase();

    let day2 = b.weekDay.toLowerCase();
    return order[day1] - order[day2];
  });
  console.log("tableData", tableData, grouped(classData, "weekDay"));
  const count =
    classData &&
    Math.ceil(classData?.totalNoOfRecords?.totalNoOfRecords / PerPage);
  const _DATA = usePagination(classData?.classes, PerPage);

  const flatListClassesData = React.useMemo(() => {
    return _DATA.currentData() || [];
  }, [classData, page, PerPage]);

  const handleChange = useCallback(
    (e, p) => {
      setPage(p);
      setOffset(p * PerPage - PerPage);
      _DATA.jump(p);
    },
    [PerPage, page]
  );

  const handleChangeFile = (file) => {
    const _file = file[0];
    // console.log(file, "_file");
    if (_file) {
      setFile(_file);
      let reader = new FileReader();
      // Convert the file to base64 text
      reader.readAsDataURL(_file);
      reader.onload = () => {
        setMediaURL(reader.result.substr(reader.result.indexOf(",") + 1));
      };
    }
  };

  React.useEffect(() => {
    getSemesterAction({ limit: 50, offSet: 0, institutionId });
    getDepartmentAction({
      department: {
        institutionId,
      },
    });
  }, []);
  React.useEffect(() => {
    if (redirect === true) {
      scrolltoView(`#classes`);
    }
    return () => {
      setRidirectAction();
    };
  }, [redirect]);

  React.useEffect(() => {
    const abortController = new AbortController();
    filterDate &&
      getClassesAction({
        fromDate: moment(filterDate[0]).format("YYYY-MM-DD"),
        toDate: moment(filterDate[1]).format("YYYY-MM-DD"),
        idFaculty: userId,
        signal: abortController.signal,
      });
    console.log("abortController", abortController);
    return () => {
      console.log("return abort", new Date().getTime(), filterDate);
      if (abortController) abortController.abort();
    };
  }, [filterDate, uploadLoading]);

  const initValues = {
    courseName: "",
    // year: "",
    fromDate: "",
    toDate: "",
  };

  return (
    <>
      {(loading || uploadLoading) && <Loader />}
      <Stack className={classes.myClass}>
        <Grid container>
          <Grid item lg={9} sm={12}>
            <Stack>
              <Box sx={{ width: "100%" }}>
                <Paper
                  sx={{
                    width: "100%",
                    borderRadius: "20px",
                    filter: "drop-shadow(0px 4px 40px rgba(0, 0, 0, 0.08))",
                    boxShadow: "none",
                  }}
                >
                  <Stack sx={{ p: 4 }}>
                    <Formik
                      initialValues={initValues}
                      validationSchema={myClassSchema}
                      validateOnBlur={false}
                      innerRef={addClassRef}
                      validateOnChange={false}
                      onSubmit={(values, { resetForm }) => {
                        if (!mediaURL) {
                          toast.error("Please upload a file.");
                          return;
                        }
                        addClassesAction({
                          ...values,
                          idFaculty: userId,
                          base64String: mediaURL,
                        });
                        setFile(null);
                        setMediaURL(null);
                        resetForm();
                        setFilterDate(date);
                        setDate();
                        scrolltoView(`#classes`);
                      }}
                    >
                      {(formik) => {
                        const {
                          errors,
                          touched,
                          handleChange,
                          handleBlur,
                          handleSubmit,
                          setFieldValue,
                          values,
                        } = formik;
                        return (
                          <form
                            onSubmit={handleSubmit}
                            className={classes.form_content}
                          >
                            <Stack sx={{ alignItems: "flex-end" }}></Stack>
                            <Grid
                              container
                              sx={{ py: 1 }}
                              className={classes.form_add_course}
                              spacing={4}
                            >
                              <Grid item md={6} sx={{ width: "100%" }}>
                                <Stack
                                  sx={{
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    fontSize:"1rem !important",
                                    fontWeight:"600 !important"
                                  }}
                                >
                                  <Stack>
                                    <Typography className={classes.label}>
                                      Department
                                    </Typography>
                                  </Stack>
                                  <Stack>
                                    <Select
                                      id="courseName"
                                      name="courseName"
                                      placeholder="Choose Department"
                                      onChange={handleChange}
                                      IconComponent={CustomExpandMore}
                                      className={
                                        errors.courseName && touched.courseName
                                          ? classes.inputError
                                          : classes.inputNoError
                                      }
                                      sx={{
                                        width: 190,
                                        fontSize:12

                                      }}
                                      value={values.courseName}
                                      displayEmpty
                                    >
                                      <MenuItem disabled value="">
                                        Select Department
                                      </MenuItem>
                                      {departmentData &&
                                        departmentData?.map(
                                          (_el, index) => (
                                            <MenuItem
                                              value={_el.name}
                                              key={index}
                                            >
                                              {_el.name}
                                            </MenuItem>
                                          )
                                        )}
                                    </Select>
                                    <ErrorMessage
                                      name="courseName"
                                      component="span"
                                      className={classes.error}
                                    />
                                  </Stack>
                                </Stack>
                              </Grid>

                              {/* <Grid item md={6} sx={{ width: "100%" }}>
                                <Stack
                                  sx={{
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <Stack>
                                    <Typography className={classes.label}>
                                      Year
                                    </Typography>
                                  </Stack>
                                  <Stack>
                                    <Select
                                      id="year"
                                      name="year"
                                      className={
                                        errors.year && touched.year
                                          ? classes.inputError
                                          : classes.inputNoError
                                      }
                                      value={values.year}
                                      onChange={handleChange}
                                      placeholder="what's your favourite car?"
                                      IconComponent={CustomExpandMore}
                                      sx={{
                                        width: 240,
                                      }}
                                      displayEmpty
                                    >
                                      <MenuItem disabled value="">
                                        <span>Semester Year</span>
                                      </MenuItem>
                                      {semesterData?.map((_el, index) => (
                                        <MenuItem value={_el.name} key={index}>
                                          {_el.name}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                    <ErrorMessage
                                      name="year"
                                      component="span"
                                      className={classes.error}
                                    />
                                  </Stack>
                                </Stack>
                              </Grid> */}
                              <Grid item md={6} sx={{ width: "100%" }}>
                                <Stack
                                  sx={{
                                    justifyContent: "space-between",
                                    flexDirection: "row",
                                    alignItems: "center",
                                  }}
                                >
                                  <Stack>
                                    <Typography className={classes.label}>
                                      Week
                                    </Typography>
                                  </Stack>
                                  <Stack>
                                    <DateRangePicker
                                      oneTap
                                      showOneCalendar
                                      isoWeek
                                      editable={false}
                                      name="rangeSelection"
                                      hoverRange="week"
                                      value={date}
                                      className={
                                        errors.fromDate && touched.fromDate
                                          ? classes.inputError
                                          : classes.inputNoError
                                      }
                                      ranges={[]}
                                      onChange={(value, e) => {
                                        setFieldValue(
                                          "fromDate",
                                          moment(value?.[0]).format(
                                            "YYYY-MM-DD"
                                          )
                                        );
                                        setFieldValue(
                                          "toDate",
                                          moment(value?.[1]).format(
                                            "YYYY-MM-DD"
                                          )
                                        );
                                        setDate(value);
                                      }}
                                      sx={{
                                        width: 190,
                                      }}
                                      style={{
                                        width: "240px",
                                      }}
                                      placeholder="Select Week"
                                      placement="auto"
                                    />
                                    <ErrorMessage
                                      name="fromDate"
                                      component="span"
                                      className={classes.error}
                                    />
                                  </Stack>
                                </Stack>
                              </Grid>
                            </Grid>
                            <Grid
                              container
                              sx={{ py: 1 }}
                              className={classes.form_add_course}
                              spacing={4}
                              marginTop={"0%"}
                            ></Grid>

                            <DropZoneUpload
                              handleChangeFile={handleChangeFile}
                            />
                            <Stack sx={{ mb: 2 }}>
                              <em style={{ marginBottom: "10px" }}>
                                {file?.name}
                              </em>
                            </Stack>
                            <Stack
                              alignItems="center"
                              sx={{
                                marginTop: "0px",
                                "& .MuiButton-root:hover": {
                                  background: `#25d5a1 !important`,
                                  color: `white !important`,
                                },
                              }}
                            >
                              <Button
                                component="label"
                                sx={{
                                  width: "30%",
                                  height: "50px",
                                  borderRadius: "22px",
                                  backgroundColor: "#25d5a1",
                                  color: "white",
                                  textTransform: "capitalize !important",
                                  fontFamily: "inter !important",
                                }}
                                type="submit"
                                onClick={handleSubmit}
                              >
                                Submit
                              </Button>
                            </Stack>
                          </form>
                        );
                      }}
                    </Formik>
                  </Stack>
                </Paper>
              </Box>
            </Stack>
            <Stack sx={{ marginTop: "20px" }}>
              <Box sx={{ width: "100%" }}>
                <Paper
                  sx={{
                    width: "100%",
                    borderRadius: "20px",
                    filter: "drop-shadow(0px 4px 40px rgba(0, 0, 0, 0.08))",
                    boxShadow: "none",
                  }}
                >
                  <Stack
                    sx={{
                      px: 4,
                      pt: 4,
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    {/* <Grid item md={6} sx={{ width: "100%" }}>
                    <Stack
                                  sx={{
                                    justifyContent: "space-between",
                                    flexDirection: "row",
                                    alignItems: "center",
                                  }}
                                > */}
                    <Stack>
                      <Typography sx={{ fontFamily: "inter", mr: 1 }}>
                        Scheduled Classes
                      </Typography>
                    </Stack>
                    <DateRangePicker
                      oneTap
                      showOneCalendar
                      isoWeek
                      editable={false}
                      hoverRange="week"
                      value={filterDate}
                      ranges={[]}
                      onChange={(value, e) => {
                        setFilterDate(value);
                      }}
                      style={{
                        width: "240px",
                      }}
                      placement="auto"
                      placeholder="Select Week"
                      // calendar={<SixDayCalendar />}
                    />
                    {/* <CustomDateRangePicker
                      value={filterDate}
                      onChange={(value, e) => {
                        setFilterDate(value);
                      }}
                    /> */}
                    {/* </Stack>
                    </Grid> */}
                  </Stack>
                  <Stack sx={{ p: 4 }}>
                    <TableContainer id="classes" sx={{ maxHeight: "400px" }}>
                      <Table
                        aria-label="sticky table"
                        className={classes.root}
                        style={{ padding: 0 }}
                      >
                        <TableHead style={{ position: "sticky", top: 0 }}>
                          {col.length > 0 && (
                            <TableRow classes={{ root: classes.thead }}>
                              <TableCell>Day</TableCell>
                              {col?.map((column) => (
                                <TableCell
                                  key={column.id}
                                  align={"center"}
                                  style={{
                                    minWidth: column.minWidth,
                                    paddingLeft: column.paddingLeft,
                                    textAlign: "left",
                                  }}
                                  classes={{ root: classes.columnData }}
                                >
                                  {`${column.start_time} - ${column.end_time}`}
                                </TableCell>
                              ))}
                            </TableRow>
                          )}
                        </TableHead>

                        <TableBody classes={{ root: classes.tBody }}>
                          {tableData && tableData?.length > 0 ? (
                            tableData?.map((_el, index) => {
                              return (
                                <TableRow tabIndex={-1} key={index}>
                                  <TableCell>{_el.weekDay}</TableCell>

                                  {sortingWithTime(tabledata[_el.weekDay]).map(
                                    (el) => (
                                      <TableCell align="center">
                                        {el.name}
                                      </TableCell>
                                    )
                                  )}
                                </TableRow>
                              );
                            })
                          ) : (
                            <TableRow>
                              <TableCell
                                colSpan={12}
                                sx={{ borderBottom: "none" }}
                              >
                                <Stack
                                  sx={{
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  No Data
                                </Stack>
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    {/* {flatListClassesData?.length > 0 && (
                    <CustomPagination
                      count={count}
                      page={page}
                      onPageChange={handleChange}
                      handlePage={handlePage}  
                      perPage={PerPage}
                    />
                  )} */}
                  </Stack>
                </Paper>
              </Box>
            </Stack>
          </Grid>
          <Grid item lg={4} sm={12}></Grid>
        </Grid>
        <DeleteModal
          setOpen={setOpen}
          open={open}
          deleteAction={deleteClassesAction}
          active={activeClass}
          textmsg={"Are you sure you want to delete this classes?"}
          component={"classes"}
        />
      </Stack>
    </>
  );
};

export default MyClasses;
